<template>
  <div>
    <p>Prihlasujem ...</p>
  </div>
</template>

<script>
import userManager from '../auth/userManagerInstance.js';
export default {
  async created() {
    try {
      var result = await userManager.signinRedirectCallback();
      var returnUrl = '/';
      if (result.state !== undefined) {
        returnUrl = result.state;
      }
      history.replaceState({}, '', '/');
      this.$router.push({ path: returnUrl });
    } catch (e) {
      console.error(e);
      this.$router.push({ name: 'Unauthorized' });
    }
  },
};
</script>
